import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router-dom"
import { getUserDetails } from "../../../api/user"

const useUserDetail = () => {
    const params  = useParams()
    return useQuery({
        queryKey : ["userDetail" , params?.id],
        queryFn : () => getUserDetails(params?.id)
    })
}

export default useUserDetail